import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  // Helper to convert neighborhood name to slug
  const toSlug = (name) => name.toLowerCase().replace(/['\s.]+/g, '-').replace(/--+/g, '-');

  const serviceAreas = [
    { name: "Queens, NY", slug: "queens-ny", neighborhoods: [
      { name: "Flushing", slug: "flushing" },
      { name: "Astoria", slug: "astoria" },
      { name: "Jamaica", slug: "jamaica" },
      { name: "Forest Hills", slug: "forest-hills" }
    ]},
    { name: "Manhattan, NY", slug: "manhattan-ny", neighborhoods: [
      { name: "Midtown", slug: "midtown" },
      { name: "Upper East Side", slug: "upper-east-side" },
      { name: "Chelsea", slug: "chelsea" },
      { name: "Harlem", slug: "harlem" }
    ]},
    { name: "Brooklyn, NY", slug: "brooklyn-ny", neighborhoods: [
      { name: "Williamsburg", slug: "williamsburg" },
      { name: "Park Slope", slug: "park-slope" },
      { name: "Bay Ridge", slug: "bay-ridge" },
      { name: "Bushwick", slug: "bushwick" }
    ]},
    { name: "Bronx, NY", slug: "bronx-ny", neighborhoods: [
      { name: "Riverdale", slug: "riverdale" },
      { name: "Fordham", slug: "fordham" },
      { name: "Pelham Bay", slug: "pelham-bay" },
      { name: "Throgs Neck", slug: "throgs-neck" }
    ]},
    { name: "Staten Island, NY", slug: "staten-island-ny", neighborhoods: [
      { name: "St. George", slug: "st-george" },
      { name: "Tottenville", slug: "tottenville" },
      { name: "Great Kills", slug: "great-kills" }
    ]},
    { name: "Nassau County", slug: "nassau-county-ny", neighborhoods: [
      { name: "Hempstead", slug: "hempstead" },
      { name: "Garden City", slug: "garden-city" },
      { name: "Levittown", slug: "levittown" }
    ]},
    { name: "Suffolk County", slug: "suffolk-county-ny", neighborhoods: [
      { name: "Huntington", slug: "huntington" },
      { name: "Smithtown", slug: "smithtown" },
      { name: "Babylon", slug: "babylon" }
    ]},
    { name: "Westchester", slug: "westchester-ny", neighborhoods: [
      { name: "Yonkers", slug: "yonkers" },
      { name: "White Plains", slug: "white-plains" },
      { name: "New Rochelle", slug: "new-rochelle" }
    ]},
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="/images/logo.png" 
              alt="Reclaim Pest Control Inc" 
              className="h-12 mb-4"
            />
            <h3 className="text-white font-bold text-lg mb-1">Reclaim Pest Control Inc</h3>
            <p className="text-gray-400 mb-4">NYC pest control and exterminator services for apartments, homes, restaurants, landlords, property managers, and commercial properties across New York City and Long Island. Licensed and insured.</p>
            <div className="space-y-2 text-gray-400">
              <p className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/></svg>
                <a href="tel:6462099955" className="hover:text-green-500" data-testid="footer-phone">(646) 209-9955</a>
              </p>
              <p className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/></svg>
                <a href="mailto:reclaimexterminating@gmail.com" className="hover:text-green-500" data-testid="footer-email">reclaimexterminating@gmail.com</a>
              </p>
              <p className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd"/></svg>
                <a href="https://www.reclaimpestcontrol.com" className="hover:text-green-500" data-testid="footer-website">www.reclaimpestcontrol.com</a>
              </p>
              <p className="flex items-center">
                <svg className="w-5 h-5 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"/></svg>
                24/7 Emergency Services
              </p>
            </div>
            
            {/* Hours of Operation */}
            <div className="mt-4 pt-4 border-t border-gray-700">
              <h5 className="text-sm font-semibold text-white mb-2">Hours of Operation</h5>
              <ul className="text-xs text-gray-400 space-y-1">
                <li className="flex justify-between"><span>Monday</span><span className="text-green-500">24 Hours</span></li>
                <li className="flex justify-between"><span>Tuesday</span><span className="text-green-500">24 Hours</span></li>
                <li className="flex justify-between"><span>Wednesday</span><span className="text-green-500">24 Hours</span></li>
                <li className="flex justify-between"><span>Thursday</span><span className="text-green-500">24 Hours</span></li>
                <li className="flex justify-between"><span>Friday</span><span className="text-green-500">24 Hours</span></li>
                <li className="flex justify-between"><span>Saturday</span><span className="text-green-500">24 Hours</span></li>
                <li className="flex justify-between"><span>Sunday</span><span className="text-green-500">24 Hours</span></li>
              </ul>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Our Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/services/rodent-control" className="hover:text-green-500">Rodent Control</Link></li>
              <li><Link to="/services/bed-bug-removal" className="hover:text-green-500">Bed Bug Removal</Link></li>
              <li><Link to="/services/cockroach-extermination" className="hover:text-green-500">Cockroach Extermination</Link></li>
              <li><Link to="/services/termite-control" className="hover:text-green-500">Termite Control</Link></li>
              <li><Link to="/services/ant-extermination" className="hover:text-green-500">Ant Extermination</Link></li>
              <li><Link to="/services/wasp-removal" className="hover:text-green-500">Wasp Removal</Link></li>
              <li><Link to="/services" className="text-green-500 font-medium hover:text-green-400">View All Services →</Link></li>
            </ul>
          </div>

          {/* Service Areas with Neighborhoods */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Service Areas</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              {serviceAreas.slice(0, 5).map((area) => (
                <li key={area.slug}>
                  <Link to={`/service-areas/${area.slug}`} className="hover:text-green-500 font-medium">{area.name}</Link>
                  <span className="text-xs block">
                    {area.neighborhoods.map((n, i) => (
                      <span key={n.slug}>
                        <Link to={`/service-areas/${area.slug}/${n.slug}`} className="text-gray-500 hover:text-green-500">{n.name}</Link>
                        {i < area.neighborhoods.length - 1 && ", "}
                      </span>
                    ))}
                  </span>
                </li>
              ))}
              <li><Link to="/service-areas" className="text-green-500 font-medium hover:text-green-400">View All Areas →</Link></li>
            </ul>
          </div>

          {/* More Areas + Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Long Island & More</h4>
            <ul className="space-y-2 text-gray-400 text-sm mb-6">
              {serviceAreas.slice(5).map((area) => (
                <li key={area.slug}>
                  <Link to={`/service-areas/${area.slug}`} className="hover:text-green-500 font-medium">{area.name}</Link>
                  <span className="text-xs block">
                    {area.neighborhoods.map((n, i) => (
                      <span key={n.slug}>
                        <Link to={`/service-areas/${area.slug}/${n.slug}`} className="text-gray-500 hover:text-green-500">{n.name}</Link>
                        {i < area.neighborhoods.length - 1 && ", "}
                      </span>
                    ))}
                  </span>
                </li>
              ))}
            </ul>
            
            <h4 className="text-lg font-semibold mb-3 text-white">Quick Links</h4>
            <ul className="space-y-1 text-gray-400">
              <li><Link to="/about" className="hover:text-green-500">About Us</Link></li>
              <li><Link to="/blog" className="hover:text-green-500">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-green-500">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-green-500">Contact Us</Link></li>
            </ul>
          </div>
        </div>

        {/* Google Map */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <h4 className="text-lg font-semibold mb-4 text-white text-center">Our Service Area</h4>
          <div className="rounded-lg overflow-hidden" style={{ height: '250px' }}>
            <iframe
              title="Reclaim Pest Control Service Area"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387193.30596073366!2d-74.25986613799748!3d40.69714941774136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1705849200000!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <p className="text-center text-gray-500 text-xs mt-2">Serving Queens, Manhattan, Brooklyn, Bronx, Staten Island, Nassau, Suffolk & Westchester</p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-6 pt-6 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Reclaim Pest Control. All rights reserved.</p>
          <p className="mt-2 text-sm">Licensed & Insured | Eco-Friendly Solutions | Serving NYC & Long Island</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
